import Alpine from "alpinejs";

Alpine.data('ListingResults', ((paginate = true, module) => ({
    filterElements: null,
    paginationValue: null,
    tagData: null,
    loading: false,
    paginate: paginate,
    module: module,
    init(){
        this.filterElements = this.$el.querySelectorAll(['input[type="checkbox"]', 'input[type="radio"']);
        let paginationEl = this.$el.querySelector('[data-pagination]')
        if(paginationEl){
            this.paginationValue = paginationEl.getAttribute('data-pagination');
        }
        this.getFilterData();
        this.bindEventListeners();
    },
    bindEventListeners(){
        this.filterElements.forEach((el) => {
            el.addEventListener('change', () => {
                this.handleChange();
            })
        })
    },
    handleChange(){
        this.loading = true;
        this.getContent();
    },

    // Convert object to query string helper
    obj2QueryString(obj){
        return Object.keys(obj)
            .map((key) => {
                let val = obj[key]
                if (val.length > 1) {
                    return val
                        .map((v) => {
                            return encodeURIComponent(key) + "=" + v.value
                        })
                        .join("&")
                } else if (Array.isArray(val)){
                    return encodeURIComponent(key) + "=" + val[0].value
                } else {
                    return encodeURIComponent(key) + "=" + val.value
                }
            })
            .join("&")
    },

    getContent() {
        const data = this.getFilterData();
        const newQuery = this.obj2QueryString(data);

        const containersToReplace = ['data-filtered-content', 'data-pagination', 'data-results-summary'];
        
        const newLocation = location.origin + location.pathname + "?" + newQuery;

        fetch(newLocation)
            .then((response) => {
                if(!module){
                    history.pushState("", "", newLocation)
                }
                return response.text()
            })
            .then((data) => {
                const parser = new DOMParser()
                const htmlResponse = parser.parseFromString(data, "text/html")
                
                containersToReplace.forEach((container) => {
                    let oldContainer = document.querySelector(`[${container}]`);
                    let newContainer = htmlResponse.documentElement.querySelector(`[${container}]`);

                    if(oldContainer && newContainer) {
                        oldContainer.innerHTML = newContainer.innerHTML;
                    }
                })
                this.loading = false
            })
            .catch((error) => {
                console.log("🤡")
                console.log(error)
            })
    },
    getFilterData(){
        let data = {};
        let tagData = [];
        
        this.filterElements.forEach((el) => {
            
            const { name, value } = el;
            const label = el.getAttribute('data-label');

            if(el.type == 'checkbox' || el.type == 'radio' ){
                if(el.checked == true) {
                    if(el.type == 'checkbox'){
                        tagData.push({value: value, label: label})
                    }

                    if(!data[name] && value != null){
                        data[name] = [{value: value, label: label}] 
                    } else {
                        data[name] = [...data[name], {value: value, label: label}];
                    }
                }
            } 
            // else if(name && value != null) {
            //     data = {
            //         ...data,
            //         [name]: {value: value, label: label}
            //     }
            // }
        });
        
        this.tagData = tagData;
        data.page = {value: this.paginationValue};

        return data;
    },
    paginate(page){
        this.paginationValue = page;
        this.handleChange();
    },
    removeFilter(value){
        let filter = Array.from(this.filterElements).find((el) => {

            return el.value == value;
        })
       filter.checked = false;
       this.handleChange();
    },
    removeFilters(){
        Array.from(this.filterElements).forEach(el => {
            if(el.type == 'checkbox'){
                el.checked = false;
            }
        })
       this.handleChange();
    }
})));